"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Takes the given objects and transforms the values with the provided
 * transformation function.
 *
 * @params {Object} object - The object you want to transform the values of.
 * @params {Function} object - The function that transforms the given key and
 *                             value to a new value.
 *
 * @example
 *
 *     transformValues(
 *       { niceFood: 'Salad', favoriteFood: 'Lasagna' },
 *       (key, value) => 'Pizza'
 *     )
 *     //=> { niceFood: 'Pizza', favoriteFood: 'Pizza' }
 */
function transformValues(object, transform) {
    return Object.entries(object).reduce((acc, [key, value]) => (Object.assign({}, acc, { [key]: transform(key, value) })), object);
}
exports.transformValues = transformValues;
//# sourceMappingURL=transform-values.js.map